// l10n status: partial
import { CreateComponent } from "components/utils/CreateComponent"
import { rootStore } from "store/RootStore"
import tvImg from "img/relatedContent/fallback_image_tv.png"
import seriesImg from "img/relatedContent/fallback_image_tv_series.png"
import serieLogo from "img/icons/series.svg"
import IconButton from "@mui/material/IconButton"
import { computed } from "mobx"
import { CALLING_CONTEXT_TYPE } from "store/page/OverlayEventDetails"
import { logResourceLoadFailure } from "utils/BugsnagReporter"
import { useState, useEffect } from "react"
//import { EventWithContent } from "store/qlapi/EpgService"
import { analyticsScreen, analyticsMeta, analyticsProgramDetailsSource } from "store/qlapi/LogService"
import { moment } from "store/util/moment"
import { getUpcomingLabelName } from "utils/Utils"
import { DiscoverConst } from "./DiscoverConst"
import { TIME_FORMAT_BACKEND } from "store/model/Time"
import { durationInHoursAndMinutes, eventType, startDateFormat, startTs, endTs, contentId, channelId, eventId, bookmarkPercentage } from "utils/EventHelpers"
import { formatMinutesLong, formatDate } from "utils/IntlManager"
import { l10n } from "store/lang/L10n"

import "scenes/components/EpisodeAndRelatedTile.css"
import { PROGRAM_ORIGIN } from "scenes/components/EpgChannelDetailsInfo"

import { getCoCoModule } from "store/page/repo/CoCoModule"
const CoCo = await getCoCoModule()

// TODO: check origin, callingContext, resetOverlay from callers 
// MTVW-947: performance, commented visible
export const GenreTile = CreateComponent(null, false, true, ({ variant, lane, isDragging, page, oEventData, item, ix, nbItems, origin, hasLiveTile = false, callingContext = CALLING_CONTEXT_TYPE.keepOldContext, resetOverlay = () => { }/*, visible = true*/ }) => {
	const pageOverlay = rootStore.page.OverlayEventDetails
	const widthStyle = {}

	const cocoBookmarks = rootStore.page.CoCoBookmarks
	const [refreshCount, setRefreshCount] = useState(0)
	const [bookmarkProgress, setBookmarkProgress] = useState(null)
	const [firstTileMarginLeft, setFirstTileMarginLeft] = useState(0)

	//console.debug("GenreTile", variant, item.program?.title, item.program?.progress, item, ix)

	function refreshBookmark() {
		let event = null
		// MTVW-1001: reset in OverlayEventDetails.setPlayEvent
		//cocoBookmarks.setIgnoreEvent(null)
		if (variant === "lane" || variant === "category") {
			if (item.program && item.program.id) {
				cocoBookmarks.getBookmarkAsync(null, false, null, item.program.id).then((bm) => {
					if (bm) {
						//console.debug("bm", bm, item.program.duration)
						// CoCo v0.5.100 returns now duration in seconds for "new-recordings", before in milliseconds
						const duration = lane?.id === "new-recordings" || lane?.id === "continue_watching" ? Number(item?.program.duration) : Number(item?.program.duration)
						const start = Number(item.program.start)
						const barProgress = 100 * (Number(bm.position) - moment(start).valueOf()) / ((moment(start).valueOf() + duration) - moment(start).valueOf())
						// MTVW-946: cap bookmark progress
						//console.debug("setBookmarkProgress", barProgress, bm.position, item.program?.title)
						setBookmarkProgress(Math.min(barProgress, 100))
					}
					else setBookmarkProgress(null)
				})
			}
			if (item.seriesEpisode && item.seriesEpisode.id) {
				const id = item.seriesEpisode.id ?? item.seriesEpisode.recordingId
				if (id) cocoBookmarks.getBookmarkAsync(null, false, null, id).then((bm) => {
					if (bm) {
						//console.debug("bm", bm, item.seriesEpisode.duration)
						// CoCo v0.5.100 returns now duration in seconds for "new-recordings", before in milliseconds
						const duration = lane?.id === "new-recordings" || lane?.id === "continue_watching" ? Number(item?.seriesEpisode.duration) : Number(item?.seriesEpisode.duration)
						const start = Number(item.seriesEpisode.start)
						const barProgress = 100 * (Number(bm.position) - moment(start).valueOf()) / ((moment(start).valueOf() + duration) - moment(start).valueOf())
						// MTVW-946: cap bookmark progress
						setBookmarkProgress(Math.min(barProgress, 100))
					}
					else setBookmarkProgress(null)
				})
			}
			//if (item.seriesFolder)
		}
		else if (variant === "related") {
			event = item.program
		}
		else if (variant === "episode") {
			//console.debug("refreshBookmark", variant, item)
			event = item
		}
		// MTVW-1157: EventWithContent -> EpgV9EventWithContent, do we still need this?
		//EpgV9EventWithContent
		//else if (item instanceof EventWithContent) {
		else if (item instanceof CoCo.EpgV9EventWithContent) {
			//console.debug("EpisodeAndRelatedTile EventWithContent", item?.event?.start, item?.content?.Title, item)
			event = item.event
		}
		// MTVW-1014: SearchMatch not used anymore
		//else if (item instanceof SearchMatch && item.type === "event") {
		else if (item.data && item.type === "event") {
			//console.debug("EpisodeAndRelatedTile SearchMatch", item?.data?.event?.start, item?.data?.content?.Title, item)
			console.debug("item.data.content.Title", item.data.content.Title)
			event = item.data.event
		}
		if (event) {
			cocoBookmarks.getBookmarkAsync(event, false).then((bm) => {
				if (bm) {
					//console.debug("useEffect EpisodeAndRelatedTile", oEventData.event.start, item.event)
					//console.debug("bookmark updated", res.position, item)
					// MTVW-899: don't hide anymore
					//const barProgress = bm.hidden ? 0 : 100 * (bm.position - event?.AvailabilityStartTs) / (event?.AvailabilityEndTs - event?.AvailabilityStartTs)
					/*
					const barProgress = 100 * (bm.position - event?.AvailabilityStartTs) / (event?.AvailabilityEndTs - event?.AvailabilityStartTs)
					// MTVW-946: cap bookmark progress
					setBookmarkProgress(Math.min(barProgress, 100))
					*/
					//console.debug("setBookmarkProgress1", bm.position, event?.title)
					setBookmarkProgress(bookmarkPercentage(bm, event))
				}
				else setBookmarkProgress(null)
			})
		}
	}

	useEffect(() => {
		refreshBookmark()
		// MTVW-931
		setFirstTileMarginLeft(rootStore.page.Discover.firstTileMarginLeft[origin])
		return () => {
		}
	}, [])

	useEffect(() => {
		if (rootStore.page.Discover.firstTileMarginLeft[origin] !== firstTileMarginLeft) setFirstTileMarginLeft(rootStore.page.Discover.firstTileMarginLeft[origin])
	}, [rootStore.page.Discover.firstTileMarginLeft[origin]])

	useEffect(() => {
		if (cocoBookmarks.refreshCount !== refreshCount) setRefreshCount(cocoBookmarks.refreshCount)
		refreshBookmark()
		// MTVW-1107: added item for bookmark refresh
	}, [cocoBookmarks.refreshCount, page.liveEvent, item])

	const episodeProgramName = (item) => {
		if (variant === "lane" || variant === "category" || variant === "related") {
			if (item.program) return item.program.title
			if (item.seriesEpisode) return item.seriesEpisode.title
			if (item.seriesFolder) return item.seriesFolder.title
		}
		else if (variant === "episode") {
			const season = item?.seasonNumber ? `S${item?.seasonNumber}` : ""
			const episode = item?.episodeNumber ? `E${item?.episodeNumber}` : ""
			const separator = season !== "" || episode !== "" ? " • " : ""
			const episodeName = item?.episodeTitle ? separator + item?.episodeTitle : separator + item?.title
			return `${season} ${episode} ${episodeName}`
		}
		else if (variant === "related") {
			return page.title(item)
		}
	}

	// MTVW-1015
	const seasonInfo = (item) => {
		if (variant === "lane" || variant === "category") {
			if (item.seriesEpisode) {
				const season = item?.seriesEpisode?.seasonNumber ? `S${item?.seriesEpisode?.seasonNumber}` : ""
				const episode = item?.seriesEpisode?.episodeNumber ? `E${item?.seriesEpisode?.episodeNumber}` : ""
				const separator = season !== "" || episode !== "" ? "• " : ""
				const episodeName = item?.seriesEpisode?.episodeTitle ? separator + item?.seriesEpisode?.episodeTitle : ""
				const info = `${season} ${episode} ${episodeName}`.trim()
				//console.debug("seasonInfo lane/category", info, info.length, item)
				return info
			}
			else return null
		}
		else if (variant === "related") {
			// TODO? Are there any recommendations with season info?
			if (item.type === "event") console.debug("seasonInfo related", item.data?.content?.title, item.data?.content?.episodeName , item)
			return null
		}
	}

	const hasSeasonInfo = (item) => {
		return seasonInfo(item)?.length > 0
		
	}

	const episodeDetails = (item) => {
		// MTVW-1149: replace formatMinutesLong(Math.round(duration)) with durationInHoursAndMinutes to show hours and minutes, also for durations > 60min
		if (variant === "lane" || variant === "category") {
			//moment(this.StartTime).format(format)
			// CoCo v0.5.100 returns now duration in seconds for "new-recordings", before in milliseconds
			if (item.program) {
				const duration = lane?.id === "new-recordings" || lane?.id === "continue_watching" ? Number(item?.program.duration) / 60000 : Number(item?.program.duration) / 60000
				const start = Number(item.program.start)
				return `${durationInHoursAndMinutes(null, duration)} • ${formatDate(moment(start), "dd, DD.MM., HH:mm")}`
			}
			if (item.seriesEpisode) {
				const duration = lane?.id === "new-recordings" || lane?.id === "continue_watching" ? Number(item?.seriesEpisode.duration) / 60000 : Number(item?.seriesEpisode.duration) / 60000
				const start = Number(item.seriesEpisode.start)
				return `${durationInHoursAndMinutes(null, duration)} • ${formatDate(moment(start), "dd, DD.MM., HH:mm")}`
			}
			if (item.seriesFolder) <></>
		}
		else if (variant === "episode") {
			const duration = Number(item?.duration) / 60000
			return `${durationInHoursAndMinutes(null, duration)} • ${startDateFormat(item, "dd, DD.MM.")}, ${startDateFormat(item, "HH:mm")}`

		}
		else if (variant === "related") {
			//console.debug("episodeDetails=", item)
			if (item?.program) {
				const duration = Number(item.program.duration) / 60000
				const start = Number(item.program.start)
				return `${durationInHoursAndMinutes(null, duration)} • ${formatDate(moment(start), "dd, DD.MM., HH:mm")}`
			}
			else return <></>
		}
	}

	const Poster = (item) => {
		let posterUrl = null
		if (variant === "lane" || variant === "category" || variant === "related") {
			if (item.program) posterUrl = item.program?.pictureUri
			if (item.seriesEpisode) posterUrl = item.seriesEpisode?.pictureUri
			if (item.seriesFolder) posterUrl = item.seriesFolder?.pictureUri
		}
		else if (variant === "episode") posterUrl = item?.pictureUri //posterUrl = item?.content?.posterUrl
		if (posterUrl) return <img loading="lazy" className="episodeImage" src={posterUrl + "?mode=box&w=480&h=270"} />
		else return <img loading="lazy" className="episodeImage" src={tvImg + "?mode=box&w=480&h=270"} />
	}

	const Logo = (item) => {
		let logoUrl = null
		if (variant === "lane" || variant === "category") {
			if (item.program) logoUrl = rootStore.channelsService?.getChannel(item.program.channelId)?.logoUrl
			if (item.seriesEpisode) logoUrl = rootStore.channelsService?.getChannel(item.seriesEpisode.channelId)?.logoUrl
			// no logoUrl for seriesFolder
			//if (item.seriesFolder) return <></>
		}
		else if (variant === "episode") logoUrl = item.channelLogoUri //rootStore.channelsService?.getChannel(item?.event?.channelId)?.logoUrl
		else if (variant === "related") {
			if (item.program) {
				logoUrl = item.program.channelLogoUri //rootStore.channelsService?.getChannel(item.program.channelId)?.logoUrl
			}
			else if (item.seriesFolder) {
				// CoCo currently returns undefined, multiple channels per series should be implemented in replayGuideMs
				logoUrl =  item.seriesFolder.channelLogoUri //rootStore.channelsService?.getChannel(item.seriesFolder.channelId)?.logoUrl
			}
			else if (item.seriesEpisode) {
				// does CoCo return series episodes for recommendations? 
				logoUrl =  item.seriesEpisode.channelLogoUri
			}
		}
		if (logoUrl) return <img loading="lazy" className="episodeChannelLogoIcon" src={logoUrl + "?mode=box&w=480&h=270"} />
		else return <></>
	}

	const recordingMarker = (item) => {
		//console.debug("recordingMarker", item)
		let evtId = null
		if (variant === "lane" || variant === "category") {
			evtId = item?.program?.id ?? item?.seriesEpisode?.id
		}
		//console.debug("recordingMaker", variant, item?.content?.Title ? item?.content?.Title : item?.data?.Title, item, page)
		else evtId = variant === "episode" ? item.id : page.id(item)
		return evtId ? rootStore.page.Recordings.Manager.getMarker(evtId) : null
	}

	const profileName = (item) => {
		const marker = recordingMarker(item)
		return marker?.ProfileId !== rootStore?.sso?.profile?.id ? rootStore.sso.getProfile(marker?.ProfileId)?.name : null
	}

	const isLive = (item) => {
		if (variant === "lane" || variant === "category") {
			if (item.program) {
				const timeCurr = moment().utc().valueOf()
				//console.debug("timeCurr", moment().format(TIME_FORMAT_BACKEND))
				// CoCo v0.5.100 returns now duration in seconds for "new-recordings", before in milliseconds
				const duration = lane?.id === "new-recordings" || lane?.id === "continue_watching" ? Number(item?.program.duration) : Number(item?.program.duration)
				const start = Number(item.program.start)
				const evType = moment(start).valueOf() <= timeCurr && (moment(start).valueOf() + duration) > timeCurr ? "c" : moment(start).valueOf() >= timeCurr ? "n" : "p"
				return evType === "c"
			}
			if (item.seriesEpisode) {
				const timeCurr = moment().utc().valueOf()
				// CoCo v0.5.100 returns now duration in seconds for "new-recordings", before in milliseconds
				const duration = lane?.id === "new-recordings" || lane?.id === "continue_watching" ? Number(item?.seriesEpisode.duration) : Number(item?.seriesEpisode.duration)
				//console.debug("isLive", duration, Number(item?.seriesEpisode.duration, item))
				const start = Number(item.seriesEpisode.start)
				const evType = moment(start).valueOf() <= timeCurr && (moment(start).valueOf() + duration) > timeCurr ? "c" : moment(start).valueOf() >= timeCurr ? "n" : "p"
				return evType === "c"
			}
			if (item.seriesFolder) return false
		}
		return variant === "episode" ? eventType(item) === "c" : page.eventType(item) === "c"
	}

	const hasUpcomingLabel = (item) => {
		let start = null
		if (variant === "lane" || variant === "category") {
			if (item.program) {
				start = Number(item.program.start)
			}
			if (item.seriesEpisode) {
				start = Number(item.seriesEpisode.start)
			}
			if (item.seriesFolder) return null
		}
		else if (variant === "episode") {
			start = startTs(item)
			//console.debug("episode check", start)
		}
		else {
			start = startTs(item?.data?.event)
			//console.debug("episode check else", start)
		}
		return getUpcomingLabelName(start)
	}

	const showThisEpiode = (item) => {
		// MTVW-931: only relevant for variant === "episode"
		/*
		if (variant === "lane") return false
		*/
		// MTVW-862: contentId instead of eventId and same channel
		if (variant === "episode") return contentId(oEventData) === contentId(item) && channelId(oEventData?.event) === item.channelId
		else return false
	}

	const getPackageLabel = (item) => {
		// TODO: CoCo fromEntertainmentPackage and fromSportsPackage
		const label = []
		if (!showThisEpiode(item)) {
			let channel = null
			if (variant === "episode") channel = rootStore.channelsService?.getChannel(item?.channelId) //rootStore.channelsService?.getChannel(item?.event?.channelId)
			else if (variant === "related") {
				if (item.program) {
					//if (item.program.fromEntertainmentPackage) console.debug("fromEntertainmentPackage", item.program.title)
					channel = rootStore.channelsService?.getChannel(item.program.channelId)
				}
				else if (item.seriesFolder) {
					channel = rootStore.channelsService?.getChannel(item.seriesFolder.channelId)
				}
				else if (item.seriesEpisode) {
					// does CoCo return series episodes for recommendations?
					channel = rootStore.channelsService?.getChannel(item.seriesEpisode.channelId)
				}
			}
			else if (variant === "lane" || variant === "category") {
				//console.debug("getPackageLabel", item)
				channel = rootStore.channelsService?.getChannel(item?.program?.channelId ?? item?.seriesEpisode?.channelId)
			}
			//if (channel) console.debug("channel=", variant, channel.packageIds, rootStore.sso.profile?.loginResult?.purchasedPackages)
			for (var i = 0; i < channel?.packageIds?.length; i++) {
				// MTVW-878: Show only "Entertainment", packageId "448"
				if (channel.packageIds[i] === "448") {
					const filtered = rootStore.sso.profile?.loginResult?.purchasedPackages?.filter(j => j.id === channel?.packageIds?.[i])
					//if (filtered) console.debug("filtered", filtered)
					if (filtered?.length > 0) label.push(filtered[0].name)
				}
			}
		}
		return label.length > 0 ? label[0] : null
	}

	// GT12: MTVW-460, MTVW-502: Channels MS flags
	// seriesId: relatedTitle?.SeriesCollection?.Series[0]?.id
	const showPlayButton = (item) => {
		// no play button anymore
		return false
		if (variant === "lane") {
			if (item.program && item.program.id) return true
			if (item.seriesEpisode && item.seriesEpisode.id) return true
			if (item.seriesFolder) return false
			return false
		}
		if (variant === "episode") {
			// TODO
			let isReplayAllowed = rootStore.page.MsEpg?.isReplayAllowed(item?.event?.channelId, startTs(item?.event), endTs(item?.event), false, null)
			if (rootStore.page.Recordings.Manager.getMarker(item?.event?.id)?.isComplete) isReplayAllowed = true
			//console.debug("allowed=", isReplayAllowed, item, page)
			return eventType(item?.event) !== "n" && isReplayAllowed
		}
		else if (variant === "related") {
			let isReplayAllowed = computed(() => rootStore.page.MsEpg?.isReplayAllowed(page.channelId(item), page.startTs(item), page.endTs(item))).get()
			// MTVW-629: commented 2nd parameter, recheck if needed
			if (rootStore.page.Recordings.Manager.getMarker(page.id(item)/*, relatedTitle?.SeriesCollection?.Series[0]?.id*/)?.isComplete) isReplayAllowed = true
			return page.eventType(item) && page.eventType(item) !== "n" && isReplayAllowed
		}
	}

	const clickHandler = (e) => {
		//console.debug("clickHandler", variant, item)
		e.preventDefault()
		e.stopPropagation()
		//const top = document.getElementsByClassName("DiscoverBody")?.[0]?.scrollTop
		//console.debug("scrollTop click", top, window.scrollY)
		rootStore.page.Discover.setDiscoverScrollPos(window.scrollY)
		//e?.nativeEvent?.stopImmediatePropagation()
		if (variant === "lane" || variant === "category") {
			const programDetails = variant === "lane" ?
				{ [analyticsMeta.screen]: analyticsScreen.programDetails, source: analyticsProgramDetailsSource.discoverLane, lane: lane?.id }
				: { [analyticsMeta.screen]: analyticsScreen.programDetails, source: analyticsProgramDetailsSource.discoverCategory, category: rootStore.page.Discover?.discoverCategory?.topCategory?.id }
			// MTVW-965: don't report for seriesFolder
			if (!item?.seriesFolder) rootStore.logService.analyticsScreenview(programDetails)
			if (item.program) {
				pageOverlay.setShow(true)
				// analytics source set above
				pageOverlay.setEpgEventById(item.program.id, false).then(res => {
					pageOverlay.setComponentType('event')
				})
			}
			if (item.seriesEpisode) {
				pageOverlay.setShow(true)
				// analytics source set above
				pageOverlay.setEpgEventById(item.seriesEpisode.id, false).then(res => {
					pageOverlay.setComponentType('event')
				})
			}
			if (item.seriesFolder) {
				// analytics source set above
				pageOverlay.setComponentType(rootStore.page.Search.CATEGORY_SERIES).setSeriesId(item.seriesFolder.seriesId)
					.setSeriesTitle(item.seriesFolder.title).setShow(true, /*callingContext*/ CALLING_CONTEXT_TYPE.keepOldContext)
			}
		}
		else if (variant === "episode") {
			// MTVW-820: Disable reopening page of "This episode"
			if (eventId(oEventData) === item.id) return
			if (pageOverlay.isVisible) {
				//console.debug("clickHandler 1", item)
				// MTVW-624: combined activityStack for related content and search
				pageOverlay.pushActivity({ type: 'related', id: eventId(oEventData) })
			}
			//console.debug("clickHandler 2", oEventData)
			// MTVW-1078, TOCHECK: calling setEpgEventById twice disabled
			//pageOverlay.setEpgEventById(eventId(oEventData), false, { ignore: true }).then(res => {
				pageOverlay.setShow(false)
				//MTV-2808 if the player in overlay is playing it must be closed
				resetOverlay()
				//MTVW-490: added setComponentType
				// setShow first so that derived 'origin' is correct
				pageOverlay.setShow(true, callingContext)
				// MTVW-965: source seriesCarousel instead of programDetails
				pageOverlay.setEpgEventById(item.id, false, { [analyticsMeta.screen]: analyticsScreen.programDetails, source: analyticsProgramDetailsSource.seriesCarousel }).then(res => {
					pageOverlay.setComponentType('event')
				})
			//})
		}
		else if (variant === "related") {
			if (item.program) {
				if (pageOverlay.isVisible) {
					// MTVW-624: combined activityStack for related content and search
					pageOverlay.pushActivity({ type: 'related', id: eventId(oEventData) })
				}
				// MTVW-1078, TOCHECK: calling setEpgEventById twice disabled
				//pageOverlay.setEpgEventById(item.program.id, false, { ignore: true }).then(res => {
					pageOverlay.setShow(false)
					//MTV-2808 if the player in overlay is playing it must be closed
					resetOverlay()
					//MTVW-490: added setComponentType
					// setShow first so that derived 'origin' is correct
					pageOverlay.setShow(true, callingContext)
					// MTVW-965: source recommendations instead of programDetails
					pageOverlay.setEpgEventById(item.program.id, false, { [analyticsMeta.screen]: analyticsScreen.programDetails, source: analyticsProgramDetailsSource.recommendations }).then(res => {
						pageOverlay.setComponentType('event')
					})
				//})
			}
			else if (item.seriesFolder) {
				if (pageOverlay.isVisible) {
					// MTVW-624: combined activityStack for related content and search
					pageOverlay.pushActivity({ type: 'related', id: eventId(oEventData) })
					//pageOverlay.pushActivity({ type: page.CATEGORY_SERIES, idSerie: page.id(item) })
				}
				pageOverlay.setComponentType(rootStore.page.Search.CATEGORY_SERIES).setSeriesId(item.seriesFolder.id)
					.setSeriesTitle(item.seriesFolder.title).setShow(true, /*callingContext*/ CALLING_CONTEXT_TYPE.keepOldContext)
			}
		}
	}

	//console.debug("firstTileMarginLeft", variant, rootStore.page.Discover.firstTileMarginLeft[origin], firstTileMarginLeft)
	// MTVW-947: performance, disabled visible
	// <div key={"episode_" + ix} style={{ visibility: visible ? "visible" : "hidden" }}>

	return refreshCount > 0 && (
		<div key={"episode_" + ix} >
			{/*console.debug("firstTileMarginLeft", firstTileMarginLeft)*/}
			{/* MTVW-931: no marginLeft for variant === "related" */}
			<div className={origin === PROGRAM_ORIGIN.discover ? "episodeTile" : "episodeTileCategory"} /*style={widthStyle}*/ style={{
				width: variant === "lane" || variant === "episode" ? DiscoverConst.tileWidth : "",
				marginLeft: ix === 0 && !hasLiveTile && variant !== "related" && variant !== "category" ? firstTileMarginLeft + "px" : 0,
				marginRight: ix === nbItems - 1 && variant !== "related" && variant !== "category" ? firstTileMarginLeft + "px" : 0
			}} onClick={(e) => {
					if (!isDragging) clickHandler(e) }
				}>
				<div className="episodeImageContainer" style={widthStyle}
				/*
				onClick={(e) => {
					e.stopPropagation()
					if (!isDragging) {
						//console.debug("isDragging=", isDragging)
						// no back button if in LiveTv
						//if (rootStore.page.Player.isPlayerOnOverlay) {
						if (rootStore.page.OverlayEventDetails.isVisible) {
							rootStore.page.OverlayEventDetails.pushActivity({ type: 'related', id: eventId(oEventData) })
						}
						rootStore.page.OverlayEventDetails.setActorName(item.name).setComponentType(rootStore.page.Search.CATEGORY_ACTORS).setShow(true, CALLING_CONTEXT_TYPE.TvGuide)
					}
				}}
				*/
				>
					{Poster(item)}
					{/* MTVW-1015: moved id to showThisEpiode(item) below*/}
					<div className="profileNameShader" style={widthStyle} /*id={variant === "episode" && eventId(oEventData) === item.event?.id ? `thisEpisode_${origin}` : `episode_${origin}_${ix}`}*/ />
					<div className="episodeIndicators">
						{/*console.debug("this episode", oEventData, item)*/}
						<div className="episodeIndicatorsFrame">
							<div className="episodeRecordingIndicator" />
						</div>
						{/* MTVW-862: contentId instead of eventId and same channel */}
						{/* MTVW-1016: fix scroll to this episode, item.content?.contentId -> item.event?.contentId */}
						{/*console.debug("showThisEpiode", contentId(oEventData) === item.event?.contentId, eventId(oEventData), item.content?.contentId )*/}
						{showThisEpiode(item) ?
							<div className="thisEpisodeIndicator" id={variant === "episode" && contentId(oEventData) === item.contentId /*item.event?.contentId*/ ? `thisEpisode_${origin}` : `episode_${origin}_${ix}`}>
								{/*console.debug("debug- check ch1 %s, ch2 %s, ch3 %o, ch4 %o, ch5 %o, ch6 %o", variant === "episode", contentId(oEventData) === item.content?.contentId, contentId(oEventData), item.content?.contentId, oEventData, item)*/}
								<div className="thisEpisodeLabel">
									<div className="thisEpisode">{l10n.featureEpisodeThisEpisode}</div>
								</div>
							</div>
							:
							<div className="thisEpisodeIndicator" style={{visibility: "hidden"}} id={`episode_${origin}_${ix}`}/>
						}
						{getPackageLabel(item) ?
							<div className="thisEpisodeIndicator">
								<div className="thisEpisodeLabel">
									<div className="thisEpisode">{getPackageLabel(item)}</div>
								</div>
							</div>
							:
							<></>
						}
					</div>
					<div className="tileIndicators">
						{recordingMarker(item) &&
							<div className="recordingIndicator">
								<div className="recordingStatusIndicator">
								   {/* MTVW-1015: data-test="episode_recorded" for BDD locator EPISODE_RECORDED */}
									<div className="recordingStatusShape" data-test="episode_recorded"/>
								</div>
								{profileName(item) &&
									<div className="recordingProfileName">{profileName(item)}</div>
								}
							</div>
						}
						<div className="availabilityIndicators">
							{isLive(item) &&
								<div className="liveIndicator">
									<div className="liveFrame">
										<div className="liveContainer">
											<div className="liveEllipse" />
										</div>
										<div className="liveLabel">{l10n.featureSearchLiveResult}</div>
									</div>
								</div>
							}
							{hasUpcomingLabel(item) &&
								<div className="upcomingIndicator">
									<div className="upcomingLabel">{hasUpcomingLabel(item)}</div>
								</div>
							}
						</div>
					</div>
					<div className="episodeChannelLogo" style={widthStyle}>
						<div className="episodeChannelLogoShader" style={widthStyle} />
						<div className="episodeChannelLogoFrame">
							<div className="episodeChannelLogoContainer" />
							{Logo(item)}
						</div>
					</div>
					{showPlayButton(item) && (
						<IconButton
							className="playButton"
							data-test="play_button_related_content"
							onClick={async (e) => {
								// MTVW-629: autoplay
								e.preventDefault()
								e.stopPropagation()
								//console.debug("rootStore.page.Player", rootStore.page.Player.player)
								rootStore.page.Player.player.setIsPosterVisible(true, "autoplay button", true)
								// necessary to move dialog on top
								//await pageOverlay.setEpgEventById(page.id(item), false)
								//pageOverlay.setShow(false)
								//MTV-2808 if the player in overlay is playing it must be closed
								// necessary to move dialog on top
								resetOverlay()
								// MTVW-629: hide overlay if liveTv
								// setShow first so that derived 'origin' is correct
								pageOverlay.setShow(!rootStore.page.Player.playerLiveTvVo.isPlayerActive, callingContext)
								if (variant === "lane" || variant === "category") {
									if (item.program && item.program.id) {
										await pageOverlay.setEpgEventById(item.program.id, true)
										pageOverlay.setComponentType('event')
										return
									}
									if (item.seriesEpisode && item.seriesEpisode.id) {
										await pageOverlay.setEpgEventById(item.seriesEpisode.id, true)
										pageOverlay.setComponentType('event')
										return
									}
									if (item.seriesFolder) return
								}
								if (variant === "episode")
									await pageOverlay.setEpgEventById(item?.event?.id, true)
								else if (variant === "related")
									await pageOverlay.setEpgEventById(page.id(item), true)
								pageOverlay.setComponentType('event')
							}}
						>
						</IconButton>
					)}
				</div>
				{/* MTVW-862: contentId instead of eventId and same channel */}
				{/*
				{variant === "episode" && contentId(oEventData?.event) === item.event?.contentId && channelId(oEventData?.event) === item.event?.channelId ?
					<div className="episodeIndicators">
						<div className="episodeIndicatorsFrame">
							<div className="episodeRecordingIndicator" />
							<div className="episodeAvailabilityIndicatorsTODO" />
						</div>
						<div className="thisEpisodeIndicator">
							<div className="thisEpisodeLabel">
								<div className="thisEpisode">{l10n.featureEpisodeThisEpisode}</div>
							</div>
						</div>
					</div>
					: <></>
				}
				*/}
				{/*console.debug("getChannel", rootStore.channelsService?.getChannel(item?.event?.channelId))*/}
				{/*
				<div className="episodeChannelLogo" style={widthStyle}>
					<div className="episodeChannelLogoShader" style={widthStyle} />
					<div className="episodeChannelLogoFrame">
						<div className="episodeChannelLogoContainer" />
						{Logo(item)}
					</div>
				</div>
				*/}
				<div className="linearProgressBarContainer">
					{/* {bookmarkProgress > 0 && */}
					{bookmarkProgress !== null &&
						<>
							<div className="linearProgressBackground" />
							<div className="linearProgress" style={{ width: bookmarkProgress + "%" }} />
						</>
					}
				</div>
				<div className="episodeInfoContainer">
					{hasSeasonInfo(item) ?
						<>
						<div className="episodeProgramNameWithEpisode">{episodeProgramName(item)}</div>
						<div className="episodeSeasonInfo"> {seasonInfo(item)} </div>
						</>
					:
						<div className="episodeProgramName">{episodeProgramName(item)}</div>
					}
					<div className="episodeDetails">{episodeDetails(item)}</div>
					{variant === "related" && (item.type === "series" || item.seriesFolder) && (
						<img loading="lazy" src={serieLogo} className="seriesIcon" alt="Serie" />
					)}
					{variant === "lane" || variant === "category" && item.seriesFolder && (
						<img loading="lazy" src={serieLogo} className="seriesIcon" alt="Serie" />
					)}
				</div>
			</div>
			{/* <div className="personName">{item.name}</div> */}
		</div>
	)
})
